import styles from "./Contact.module.css"
import FormPage from "../ui/form/Form";

import {BsPersonFill} from 'react-icons/bs'
import {FaMapMarkedAlt} from 'react-icons/fa'
import {HiOutlinePhone} from 'react-icons/hi'
import {FaPaperPlane} from 'react-icons/fa'

const Contact = () => {

    return (
        <section className={styles.contact} id='contact'>
            <div className={styles.width}>
                <div className={styles.titleWrapper}>
                    <h1 className={styles.title} >Get In Touch </h1>
                    <span className={styles.bgTitle}>Contact</span>
                </div>
                <div className={`h-full w-full flex-wrap flex relative z-10 ${styles.justify}`}>
                    <div className={`${styles.minWidth}`}>
                            <h1 className={styles.titleInside}>Message me</h1>
                            <FormPage/>
                        </div>
                    <div className={`w-2/5 ${styles.minWidth}`}>
                            <h1 className={styles.titleInside}>Contact info</h1>
                            <p className={styles.textInside}>Always available for freelance work if the right project comes along, Feel free to contact me!</p>
                            <div className={`flex mt-7`}>
                                <div className='flex flex-col justify-around h-full'>
                                      <BsPersonFill className={styles.icon}/>
                                      <FaMapMarkedAlt className={styles.icon}/>
                                     <HiOutlinePhone className={styles.icon}/>
                                     <FaPaperPlane className={styles.icon}/>
                                </div>
                                <div className={styles.secondBlock}>
                                    <div className={styles.block}>
                                        <p className={styles.textPreTitle}>Name </p>
                                        <p className={styles.textInfo}>David</p>
                                    </div>
                                    <div className={styles.block}>
                                        <p className={styles.textPreTitle}>Location </p>
                                        <p className={styles.textInfo}>Riga,Latvia</p>
                                    </div >
                                    <div className={styles.block}>
                                        <p className={styles.textPreTitle}>Call Me </p>
                                        <a href="tel:+37128721662" className={styles.textInfo} datatype="hoverable">+371 28721662</a>
                                    </div>
                                    <div className={styles.block}>
                                        <p className={styles.textPreTitle}>Email Me </p>
                                        <a href="mailto:david.bogomolov2@gmail.com" className={styles.textInfo} datatype="hoverable">david.bogomolov2@gmail.com</a>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </section>
    )
}


export default Contact